export const preFilter = (
  mainData,
  isCheck,
  configFilter,
  compactColumns = [],
  compactColumnsSplit = [],
  setPreFilteredData,
  setDataFilter
) => {
  const isMissingValue = (value) => {
    if (value === undefined || value === null) {
      return true;
    }

    if (typeof value === "string") {
      const normalizedValue = value.trim().toUpperCase();
      return normalizedValue === "" || normalizedValue === "N/A" || normalizedValue === "NA";
    }

    return false;
  };

  const preFilter = mainData?.reduce((acc, originalItem, index) => {

    let item = { ...originalItem };

    const data = isCheck ? compactColumnsSplit : compactColumns;

    if (compactColumns || compactColumnsSplit) {
      data.forEach((compactColumn) => {
        const valueBelong = item[compactColumn.dataSearch]?.toLowerCase();
        const hasDefaultValue = Object.prototype.hasOwnProperty.call(compactColumn, "defaultValue");

        if (hasDefaultValue) {
          item[compactColumn.nameColumn] = compactColumn.defaultValue;
        }
        compactColumn.rowSelect.forEach((element) => {
          if (valueBelong === element.value.toLowerCase()) {
            const sourceValue = item[element.dataSearch];
            let value = hasDefaultValue && isMissingValue(sourceValue)
              ? compactColumn.defaultValue
              : (sourceValue === "" ? "N/A" : sourceValue);
            item[compactColumn.nameColumn] = value;
          }
        });
      });
    }

    if (
      item[
        isCheck
          ? configFilter[1].split.dataSearch
          : configFilter[0].full.dataSearch
      ].toLowerCase() ===
      (isCheck
        ? configFilter[1].split.keyFilter.toLowerCase()
        : configFilter[0].full.keyFilter.toLowerCase())
    ) {
      acc.push({ ...item, originalIndex: index });
    }
    return acc;
  }, []);

  setPreFilteredData(preFilter);
  setDataFilter(preFilter);
};